<div class="container">
  @if (isOnboarding()) {
    <div class="stepper">
      <div class="stepContainer">
        <div class="step">1</div>
      </div>
      <div class="stepContainer active">
        <div class="step">2</div>
      </div>
      <div class="stepContainer">
        <div class="step">3</div>
      </div>
      @if (shouldDisplayFourthStep()) {
        <div class="stepContainer">
          <div class="step">4</div>
        </div>
      }
    </div>
  }
  <div class="titleContainer marginTop">
    <div class="title">{{ 'onboarding.2.title' | translate }}</div>
  </div>
  <div class="avatarGrid row row-gap-3">
    @for (avatar of avatars; track avatar) {
      <div class="avatar col-4">
        <ng-lottie
          [options]="avatarAnimationOptionsForAvatar(avatar)"
          (click)="select(avatar)"
          class="img"
          [class.active]="selectedAvatar === avatar"
          [style.background-color]="getBackgroundColorForAvatar(avatar)"
          (error)="onError($event)"
        ></ng-lottie>
        @if (selectedAvatar === avatar) {
          <div class="overlay">
            <i class="bi bi-check-circle-fill"></i>
          </div>
        }
      </div>
    }
  </div>
  <div class="nextBtnContainer">
    <div (click)="next()" class="nextButton" [class.disabled]="selectedAvatar === undefined">
      {{ isOnboarding() ? ('common.buttons.next' | translate) : ('common.buttons.save' | translate) }}
    </div>
  </div>
</div>
